var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditjarFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 43,
    viewBox: "0 0 37 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6634 10.2035V6.08309C20.7033 6.09753 18.4221 7.97801 17.2477 10.2356H23.1082C23.1948 10.2356 23.2812 10.2368 23.3672 10.2391C23.4634 10.2235 23.5621 10.2115 23.6634 10.2035Z",
    fill: "url(#paint0_linear_301_1580)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5367 12.1688C16.4209 12.6864 16.3638 13.2036 16.3695 13.7053H20.3617C20.3365 13.4987 20.375 13.202 20.4788 12.8698C20.5899 12.5141 20.7769 12.1139 21.0458 11.7335C21.5351 11.0414 22.2969 10.413 23.3672 10.2391C23.2812 10.2368 23.1948 10.2356 23.1082 10.2356H17.2477C16.9231 10.8595 16.6831 11.5141 16.5367 12.1688Z",
    fill: "url(#paint1_linear_301_1580)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3003 18.2159C21.3217 18.2162 21.3431 18.2164 21.3647 18.2165C21.3666 18.2165 21.3684 18.2165 21.3703 18.2166C21.3924 18.217 21.4144 18.2177 21.4364 18.2185L20.436 13.7339C20.4344 13.7246 20.4329 13.7151 20.4316 13.7053H20.3617C20.3634 13.7193 20.3654 13.7328 20.3677 13.746L20.3678 13.7468L20.368 13.7475L21.3647 18.2165C21.3445 18.2161 21.3242 18.2159 21.3039 18.2159H21.3003Z",
    fill: "url(#paint2_linear_301_1580)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6634 6.08309V10.2035C23.5621 10.2115 23.4634 10.2235 23.3672 10.2391C23.4897 10.2424 23.6115 10.248 23.7327 10.2559V6.08605C23.7096 6.085 23.6865 6.08401 23.6634 6.08309Z",
    fill: "url(#paint3_linear_301_1580)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6012 42.7814V38.6177C8.38898 38.6177 4.16364 34.3924 4.16364 29.1801V19.6732C4.16364 14.7297 7.96443 10.674 12.8032 10.2689C12.8148 10.2683 12.8263 10.2678 12.8379 10.2671C15.2686 10.0169 17.048 8.20034 17.587 6.07197H17.0096H13.8441H13.6012C13.4619 6.07197 13.3231 6.07406 13.1848 6.07822C13.1215 6.08012 13.0583 6.08246 12.9953 6.08523C5.7647 6.40223 4.56865e-08 12.3645 0 19.6732V29.1801L0.00027107 29.2681C0.047588 36.7394 6.11881 42.7814 13.6012 42.7814Z",
    fill: "url(#paint4_linear_301_1580)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7005 10.2702L23.7327 10.2679V10.2559C23.6115 10.248 23.4897 10.2424 23.3672 10.2391C22.2969 10.413 21.5351 11.0414 21.0458 11.7335C20.7769 12.1139 20.5899 12.5141 20.4788 12.8698C20.375 13.202 20.3365 13.4987 20.3617 13.7053H20.4316C20.4252 13.6569 20.4226 13.6024 20.424 13.5426C20.428 13.3646 20.4672 13.1398 20.545 12.8905C20.654 12.5415 20.8379 12.1479 21.1024 11.7737C21.6314 11.0253 22.4815 10.3561 23.7005 10.2702Z",
    fill: "url(#paint5_linear_301_1580)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1082 38.6177V42.7814L23.1961 42.7811C30.6381 42.734 36.662 36.7101 36.7091 29.2681L36.7094 29.1801V19.6732C36.7094 12.3708 30.9546 6.41246 23.7327 6.08605V10.2559C28.6538 10.5775 32.5457 14.6708 32.5457 19.6732V29.1801C32.5457 34.3924 28.3204 38.6177 23.1082 38.6177Z",
    fill: "url(#paint6_linear_301_1580)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3039 30.6374V35.148C25.5964 35.148 29.0761 31.6683 29.0761 27.3759V21.4774C29.0761 17.185 25.5964 13.7053 21.3039 13.7053H20.5753H20.4316C20.4329 13.7151 20.4344 13.7246 20.436 13.7339L21.4364 18.2185C23.1763 18.2881 24.5654 19.7205 24.5654 21.4774V27.3759C24.5654 29.1772 23.1052 30.6374 21.3039 30.6374Z",
    fill: "url(#paint7_linear_301_1580)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4054 35.148V30.6374C13.6042 30.6374 12.1439 29.1772 12.1439 27.3759V21.4774C12.1439 19.6761 13.6042 18.2159 15.4054 18.2159H16.9321C15.4054 17.3485 14.6053 15.5789 14.6053 13.746C10.6888 14.1465 7.63333 17.4552 7.63333 21.4774V27.3759C7.63333 31.6348 11.0589 35.0936 15.305 35.1474L15.4054 35.148Z",
    fill: "url(#paint8_linear_301_1580)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3039 35.148V30.6374H15.4054V35.148H21.3039Z",
    fill: "url(#paint9_linear_301_1580)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1082 42.7814V38.6177H13.6012V42.7814H23.1082Z",
    fill: "url(#paint10_linear_301_1580)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3647 18.2165C21.3431 18.2164 21.3217 18.2162 21.3003 18.2159C19.2446 18.1906 17.8939 17.439 17.1348 16.328C16.6256 15.5828 16.3806 14.6728 16.3695 13.7053H20.3617C20.3634 13.7193 20.3654 13.7328 20.3677 13.746L20.3678 13.7468L20.368 13.7475L21.3647 18.2165Z",
    fill: "url(#paint11_linear_301_1580)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6012 6.07197H13.8441H17.0096H17.587C18.1268 3.94086 17.4231 1.49712 14.885 0L13.0227 3.435C13.6517 3.71405 14.4228 4.95509 13.2383 6.03098C13.2209 6.04676 13.2031 6.06251 13.1848 6.07822C13.3231 6.07406 13.4619 6.07197 13.6012 6.07197Z",
    fill: "url(#paint12_linear_301_1580)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1848 6.07822C13.2031 6.06251 13.2209 6.04676 13.2383 6.03098C13.1964 6.06622 13.0993 6.08007 12.9953 6.08523C13.0583 6.08246 13.1215 6.08012 13.1848 6.07822Z",
    fill: "url(#paint13_linear_301_1580)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4316 13.7053H20.5753C20.4712 13.7053 20.4253 13.6359 20.424 13.5426C20.4226 13.6024 20.4252 13.6569 20.4316 13.7053Z",
    fill: "url(#paint14_linear_301_1580)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6634 10.2035V6.08309C20.7033 6.09753 18.4221 7.97801 17.2477 10.2356H23.1082C23.1948 10.2356 23.2812 10.2368 23.3672 10.2391C23.4634 10.2235 23.5621 10.2115 23.6634 10.2035Z",
    fill: "url(#paint15_linear_301_1580)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5367 12.1688C16.4209 12.6864 16.3638 13.2036 16.3695 13.7053H20.3617C20.3365 13.4987 20.375 13.202 20.4788 12.8698C20.5899 12.5141 20.7769 12.1139 21.0458 11.7335C21.5351 11.0414 22.2969 10.413 23.3672 10.2391C23.2812 10.2368 23.1948 10.2356 23.1082 10.2356H17.2477C16.9231 10.8595 16.6831 11.5141 16.5367 12.1688Z",
    fill: "url(#paint16_linear_301_1580)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3003 18.2159C21.3217 18.2162 21.3431 18.2164 21.3647 18.2165C21.3666 18.2165 21.3684 18.2165 21.3703 18.2166C21.3924 18.217 21.4144 18.2177 21.4364 18.2185L20.436 13.7339C20.4344 13.7246 20.4329 13.7151 20.4316 13.7053H20.3617C20.3634 13.7193 20.3654 13.7328 20.3677 13.746L20.3678 13.7468L20.368 13.7475L21.3647 18.2165C21.3445 18.2161 21.3242 18.2159 21.3039 18.2159H21.3003Z",
    fill: "url(#paint17_linear_301_1580)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6634 6.08309V10.2035C23.5621 10.2115 23.4634 10.2235 23.3672 10.2391C23.4897 10.2424 23.6115 10.248 23.7327 10.2559V6.08605C23.7096 6.085 23.6865 6.08401 23.6634 6.08309Z",
    fill: "url(#paint18_linear_301_1580)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7005 10.2702L23.7327 10.2679V10.2559C23.6115 10.248 23.4897 10.2424 23.3672 10.2391C22.2969 10.413 21.5351 11.0414 21.0458 11.7335C20.7769 12.1139 20.5899 12.5141 20.4788 12.8698C20.375 13.202 20.3365 13.4987 20.3617 13.7053H20.4316C20.4252 13.6569 20.4226 13.6024 20.424 13.5426C20.428 13.3646 20.4672 13.1398 20.545 12.8905C20.654 12.5415 20.8379 12.1479 21.1024 11.7737C21.6314 11.0253 22.4815 10.3561 23.7005 10.2702Z",
    fill: "url(#paint19_linear_301_1580)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3039 30.6374V35.148C25.5964 35.148 29.0761 31.6683 29.0761 27.3759V21.4774C29.0761 17.185 25.5964 13.7053 21.3039 13.7053H20.5753H20.4316C20.4329 13.7151 20.4344 13.7246 20.436 13.7339L21.4364 18.2185C23.1763 18.2881 24.5654 19.7205 24.5654 21.4774V27.3759C24.5654 29.1772 23.1052 30.6374 21.3039 30.6374Z",
    fill: "url(#paint20_linear_301_1580)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4054 35.148V30.6374C13.6042 30.6374 12.1439 29.1772 12.1439 27.3759V21.4774C12.1439 19.6761 13.6042 18.2159 15.4054 18.2159H16.9321C15.4054 17.3485 14.6053 15.5789 14.6053 13.746C10.6888 14.1465 7.63333 17.4552 7.63333 21.4774V27.3759C7.63333 31.6348 11.0589 35.0936 15.305 35.1474L15.4054 35.148Z",
    fill: "url(#paint21_linear_301_1580)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3039 35.148V30.6374H15.4054V35.148H21.3039Z",
    fill: "url(#paint22_linear_301_1580)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3647 18.2165C21.3431 18.2164 21.3217 18.2162 21.3003 18.2159C19.2446 18.1906 17.8939 17.439 17.1348 16.328C16.6256 15.5828 16.3806 14.6728 16.3695 13.7053H20.3617C20.3634 13.7193 20.3654 13.7328 20.3677 13.746L20.3678 13.7468L20.368 13.7475L21.3647 18.2165Z",
    fill: "url(#paint23_linear_301_1580)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1848 6.07822C13.2031 6.06251 13.2209 6.04676 13.2383 6.03098C13.1964 6.06622 13.0993 6.08007 12.9953 6.08523C13.0583 6.08246 13.1215 6.08012 13.1848 6.07822Z",
    fill: "url(#paint24_linear_301_1580)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4316 13.7053H20.5753C20.4712 13.7053 20.4253 13.6359 20.424 13.5426C20.4226 13.6024 20.4252 13.6569 20.4316 13.7053Z",
    fill: "url(#paint25_linear_301_1580)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4054 35.148V30.6374C13.6042 30.6374 12.1439 29.1772 12.1439 27.3759V21.4774C12.1439 19.6761 13.6042 18.2159 15.4054 18.2159H16.9321C15.4054 17.3485 14.6053 15.5789 14.6053 13.746C10.6888 14.1465 7.63333 17.4552 7.63333 21.4774V27.3759C7.63333 31.6348 11.0589 35.0936 15.305 35.1474L15.4054 35.148Z",
    fill: "#F1D506"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1848 6.07822C13.2031 6.06251 13.2209 6.04676 13.2383 6.03098C13.1964 6.06622 13.0993 6.08007 12.9953 6.08523C13.0583 6.08246 13.1215 6.08012 13.1848 6.07822Z",
    fill: "#F1D506"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4316 13.7053H20.5753C20.4712 13.7053 20.4253 13.6359 20.424 13.5426C20.4226 13.6024 20.4252 13.6569 20.4316 13.7053Z",
    fill: "#F1D506"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3003 18.2159C21.3217 18.2162 21.3431 18.2164 21.3647 18.2165C21.3445 18.2161 21.3242 18.2159 21.3039 18.2159H21.3003Z",
    fill: "#F1D506"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3647 18.2165C21.3431 18.2164 21.3217 18.2162 21.3003 18.2159H21.3039C21.3242 18.2159 21.3445 18.2161 21.3647 18.2165Z",
    fill: "#F1D506"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_301_1580",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_301_1580",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_301_1580",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_301_1580",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_301_1580",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_301_1580",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_301_1580",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_301_1580",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_301_1580",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_301_1580",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_301_1580",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_301_1580",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditjarFavicon);
export default __webpack_public_path__ + "static/media/creditjarFavicon.6102a5d71d1f5da68672db036de2f8b7.svg";
export { ForwardRef as ReactComponent };